import React, { useState } from "react";
import { api } from "../../lib/api";

const usd = (c) => `$${(c / 100).toLocaleString("en-US", { minimumFractionDigits: 2 })}`;
const IN = "min-h-[44px] rounded border border-erf-borderCream px-3 bg-white text-sm";
const BTN = "min-h-[44px] px-4 rounded-sm text-sm font-semibold border border-erf-borderCream";

// Setup step 1: budget by cost code. Hidden for roles without project financials access (B2b matrix).
export default function SetupBudget({ s, pid, run }) {
  const [ln, setLn] = useState({ cost_code: "", description: "", amount: "" });
  if (s.budget_hidden) return <p className="text-sm" data-testid="pm-setup-budget-hidden">1. Budget: not shown for your role.</p>;
  const add = (e) => {
    e.preventDefault();
    run(api.post(`/pm/projects/${pid}/setup/budget-lines`, { cost_code: ln.cost_code, description: ln.description,
      budget_cents: Math.round(Number(ln.amount) * 100) }), "Budget line added.").then(() => setLn({ cost_code: "", description: "", amount: "" }));
  };
  return (
    <section className="space-y-2" data-testid="pm-setup-budget">
      <h2 className="font-heading text-lg">1. Budget by cost code</h2>
      <ul className="text-sm space-y-1">{s.budget.lines.map((b) => (
        <li key={b.id} className="flex gap-2" data-testid={`pm-setup-budget-${b.cost_code}`}><span className="font-semibold">{b.cost_code}</span><span className="min-w-0 break-words">{b.description}</span><span className="ml-auto">{usd(b.budget_cents)}</span></li>))}
      </ul>
      <p className="text-sm font-semibold" data-testid="pm-setup-budget-total">{s.budget.lines.length ? `Total ${usd(s.budget.total_cents)}` : "No budget lines yet."}</p>
      {s.can.budget && (s.estimates || []).map((e) => (
        <button key={e.id} type="button" className={BTN} onClick={() => run(api.post(`/pm/projects/${pid}/setup/budget-from-estimate`, { estimate_id: e.id }), "Budget built from the estimate.")}
          data-testid={`pm-setup-from-estimate-${e.id}`}>Build budget from estimate “{e.name}”</button>))}
      {s.can.budget && (
        <form onSubmit={add} className="flex flex-wrap gap-2 items-end">
          <label className="text-xs flex flex-col">Cost code<input className={IN} value={ln.cost_code} onChange={(e) => setLn({ ...ln, cost_code: e.target.value })} data-testid="pm-setup-bl-code" /></label>
          <label className="text-xs flex flex-col">Description<input className={IN} value={ln.description} onChange={(e) => setLn({ ...ln, description: e.target.value })} data-testid="pm-setup-bl-desc" /></label>
          <label className="text-xs flex flex-col">Amount ($)<input type="number" min="0" step="0.01" className={IN} value={ln.amount} onChange={(e) => setLn({ ...ln, amount: e.target.value })} data-testid="pm-setup-bl-amount" /></label>
          <button type="submit" className={BTN} data-testid="pm-setup-bl-add">Add line</button>
        </form>
      )}
    </section>
  );
}
